import { FSharpResult_Case_Error } from "../@client/Microsoft_FSharp_Core"

export function isFsharpErrorResult(
  x: any
): x is FSharpResult_Case_Error<string> {
  return x?.Case === "Error" && typeof x.Fields === "string"
}
